import scales from '../foundational-styles/scales';
var overlayBackgroundColor = scales.neutral.N7A;
export default overlayBackgroundColor;